export var ACTION;
(function (ACTION) {
    ACTION["GO_BACK"] = "GO_BACK";
    ACTION["NAVIAGTE_TO_DASHBOARD"] = "NAVIAGTE_TO_DASHBOARD";
    ACTION["NAVIAGTE_TO_REASON_PAGE"] = "NAVIAGTE_TO_REASON_PAGE";
    ACTION["CLOSE_MODAL"] = "CLOSE_MODAL";
    ACTION["INPROGRESS_PROCESS_NAVIGATE"] = "INPROGRESS_PROCESS_NAVIGATE";
})(ACTION || (ACTION = {}));
